import React, { FC } from "react";
import { StoryDescription } from "../data/StoryDescription";
import { StoryType } from "../enums";
import { ChatItem, Story } from "../types";
import { ChoiceCard } from "./Card";
import { Heading } from "./Heading";
import Text from "./Text";

export interface StoryComponentProps {
  story: Story;
}

export const StoryComponent: FC<StoryComponentProps> = ({
  story,
}: StoryComponentProps) => {
  return story.type !== StoryType.CEWarning ? (
    <div
      key={story.title}
      className="w-full flex flex-col py-5 -my-2"
      id={story.slug}
    >
      <Heading
        text={story.title + (story.time ? ` (${story.time})` : "")}
        hash={story.slug!}
      />
      {story.description && (
        <Text.Body className="w-full px-4 text-gray-common text-center mb-1 -mt-1">
          <StoryDescription k={story.description} />
        </Text.Body>
      )}
      <div className="w-full flex flex-col space-y-1">
        {story.choices.map((choice: (ChatItem | string)[], idx: number) => (
          <ChoiceCard key={idx} data={choice} />
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};
